import { frFR } from '@clerk/localizations';

export const frCA: typeof frFR = {
  ...frFR,
  locale: 'fr-CA',
};
